import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const classifiedAdvertising = {
    name: 'Classified advertising',
    slug: 'classified-advertising',
    description: 'Free of charge online classified advertisements project with sections devoted to jobs, housing, cars, phones, services, etc.',
    cover: { 
        url: `${PUBLIC_URL}/portfolio/classified/cover.jpg`,
        license: {
            link: 'http://www.freepik.com', 
            text: 'Designed by Freepik' 
        }
    },
    prominentColor: 'rgb(67,150,225)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/classified/online-shopping.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by pikisuperstar / Freepik'
                    }
                }, {
                    url: `${PUBLIC_URL}/portfolio/classified/online-shopping2.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by pikisuperstar / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/classified/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Highlights',
            description: 'Investment acquired startup',
        } as PieceDescription,
        {
            type: 'description',
            title: 'Role',
            description: 'Back End developer.',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['PHP', 'MySQL', 'Memcached'],
        } as PieceUnorderedList
    ],
}

export default classifiedAdvertising;


// WEBPACK FOOTER //
// ./src/store/portfolio/classified-advertising.tsx